import { openChatBox } from '../../helpers/utils'
import NewSecondaryButton from '../Buttons/NewSecondaryButton'
import BookACallButton from '../Buttons/Specials/BookACallButton'

export default function NeedHelp({ Modal }) {
    return (
        <div className="container mx-auto px-8 my-20">
            <div className="flex flex-col items center text-center space-y-8">
                <h3 className="font-bold md:text-5xl/[1.15] text-3xl">
                    Need Help?
                </h3>
                <p className="md:w-3/4 mx-auto md:text-xl text-base/7">
                    Not sure where to begin or need advice on your mail
                    strategy? Our experts are here to assist you. Contact us
                    today for personalized guidance and support to ensure your
                    direct mail campaigns achieve the best results.
                </p>
                <div className="w-full max-w-xl m-auto">
                    <div className="grid grid-flow-row md:grid-flow-col md:grid-cols-2 gap-4">
                        {Modal ? (
                            <BookACallButton Modal={Modal} />
                        ) : (
                            <BookACallButton />
                        )}
                        <NewSecondaryButton onClick={openChatBox}>
                            Talk with us
                        </NewSecondaryButton>
                    </div>
                </div>
            </div>
        </div>
    )
}
